import { url, setTip, scenesList, bi, customDialogSceneID } from './gb'
import Login from './login'
import { Role, userInfo, roleList, isRoleBind } from './role'
import fullPage from './fullpage'

let sceneGettedList,
  isInit = 1,
  sceneStatus,
  actCareer = 12 //12

const Scene = {
  api_sceneInit: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.sceneList,
        dataType: 'jsonp',
      }).done((d) => {
        if (d.success) {
          sceneGettedList = d.data
          Scene.UI_sceneGetted()
          resolve()
        } else {
          setTip(d.messages)
          reject(d.messages)
        }
      })
    })
  },
  api_submitScene: (id) => {
    $.ajax({
      url: url.submitScene,
      data: {
        scene_id: id,
      },
      dataType: 'jsonp',
    }).done((d) => {
      if (d.success) {
        Scene.UI_submitScene(id)
      } else {
        if (d.code != 10010) {
          setTip(d.messages)
        }
      }
    })
  },
  api_sceneStatusInit: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.sceneStatusInit,
        dataType: 'jsonp',
      }).done((d) => {
        if (d.success) {
          sceneStatus = d.data
          Scene.UI_sceneStatusInitUnLogin()
          resolve()
        } else {
          setTip(d.messages)
          reject(d.messages)
        }
      })
    })
  },
  UI_sceneReset: () => {
    Object.keys(scenesList).forEach((ele) => {
      $(scenesList[ele].btn).hasClass('disabled') &&
        $(scenesList[ele].btn)
          .removeClass('disabled')
          .closest('.item')
          .removeClass('disabled')
      !$(scenesList[ele].btn).hasClass('predisabled') &&
        $(scenesList[ele].btn)
          .addClass('predisabled')
          .closest('.item')
          .addClass('predisabled')

      if (isInit) {
        $(scenesList[ele].btn).attr('data-scene-id', ele)
      }
    })
    isInit = 0
  },
  UI_sceneGetted: () => {
    sceneGettedList.forEach((ele) => {
      if (scenesList[ele]) {
        $(scenesList[ele].btn)
          .removeClass('predisabled')
          .addClass('disabled')
          .closest('.item')
          .removeClass('predisabled')
          .addClass('disabled')
      }
    })
  },
  UI_sceneStatusInitUnLogin: () => {
    $('[data-career-cnt]').text(sceneStatus.career12_cnt)
  },
  UI_sceneStatusInit: () => {
    // 老玩家礼包
    userInfo.rolectime < sceneStatus.vtime_1_8_0 &&
      $('[data-btn-lb-lwj]').removeClass('predisabled')

    // 领取武当礼包前置条件判断
    if (
      (userInfo.career == actCareer &&
        userInfo.parent_uid &&
        userInfo.parent_role_id.length) ||
      userInfo.invite_careers.filter((i) => {
        return i == actCareer
      }).length
    ) {
      $(`[data-btn-lb-${customDialogSceneID + 1}]`).removeClass('predisabled')
    }

    if (userInfo.career == actCareer && userInfo.level >= 30) {
      $(`[data-btn-lb-${customDialogSceneID + 2}]`).removeClass('predisabled')
    }

    userInfo.pupil_careers.filter((i) => {
      return i == actCareer
    }).length &&
      $(`[data-btn-lb-${customDialogSceneID + 3}]`).removeClass('predisabled')
  },
  UI_submitScene: (id) => {
    $('[data-scene-id=' + id + ']').addClass('disabled')
    if (id == customDialogSceneID) {
      showCustomDialog()
    } else {
      $('[data-dialog-confirm]').show()
    }
    fullPage.lockScroll()
  },
}

const showCustomDialog = () => {
  $(`[data-dialog-friend] [data-btn-target="${customDialogSceneID}"]`)
    .show()
    .siblings('.note')
    .hide()
  $('[data-dialog-friend]').show()

  bi('按钮-邀约武当礼包')
}

$(document).on('click', '[data-scene-id]', async (e) => {
  await Login.checkLogin()
  Role.trigger_submitTarget($(e.target))

  // 提示：没有达到领取条件
  if (
    $(e.target).hasClass('predisabled') &&
    scenesList[$(e.target).data('scene-id')].tip &&
    isRoleBind
  ) {
    setTip(scenesList[$(e.target).data('scene-id')].tip)
    return
  }

  // 提示：已领取
  if ($(e.target).hasClass('disabled')) {
    // 邀约武当
    if (parseInt($(e.target).data('scene-id')) == customDialogSceneID) {
      showCustomDialog()
      fullPage.lockScroll()
    } else {
      setTip('您已经领过了')
    }
    return
  }

  if (roleList.length > 0) {
    Scene.api_submitScene($(e.target).data('scene-id'))
  } else {
    Role.state_roleUnbind()
  }
  bi('按钮-领礼包' + scenesList[$(e.target).data('scene-id')].sceneType)
})

export default Scene
